import { jsx } from '@emotion/react';
import * as styles from './styles';

export type DimensionType =
  | '4xl'
  | '2xl'
  | 'xl'
  | 'lg'
  | 'md'
  | 'sm'
  | 'xs'
  | 'tiny';

type Props = {
  children?: React.ReactNode;
  bold?: boolean;
  inline?: boolean;
  leading?: DimensionType;
  size?: DimensionType;
  tag?: string;
  [key: string]: any;
};

export default function Text({
  children,
  bold = false,
  inline = false,
  leading = 'md',
  size = 'md',
  tag,
  ...args
}: Props) {
  return jsx(
    tag ? tag : inline ? 'span' : 'p',
    {
      css: [styles.container, styles.makeUp({ bold, leading, size })],
      ...args,
    },
    children
  );
}
